/**
 * Format money for ESC/POS / TSPL thermal printers.
 *
 * Do not use `Intl.NumberFormat({ style: 'currency' })` here: for codes like LKR it
 * inserts a narrow/no-break space (U+00A0 / U+202F) between the currency and amount.
 * Those bytes are not in CP437 and print as a garbage glyph on the slip.
 */
export function formatThermalMoney(value: number, currency = 'LKR'): string {
  const code = String(currency ?? '')
    .trim()
    .toUpperCase()
    .replace(/[^A-Z]/g, '')
    .slice(0, 3);
  const amount = (Number.isFinite(value) ? value : 0).toFixed(2);
  return `${code || 'LKR'} ${amount}`;
}
